// Deterministic colony-colour palette + label (match-screen design D-match-2/D-match-1,
// tasks.md 3.2): shared across the leaderboard dot (group 4), the canvas hive/queen
// marker, and the swarm blob (group 3) — derived solely from the colony id, never a
// name (colony display names are not on the wire, D-074) and never per-render
// randomness. Returns `var(--colony-N)` token strings so this helper is unit-tested
// before the `--colony-*` ramp itself lands in `prototype/tokens/colors.css` (group
// 5) — the `colony-screen` `--bee-ext-*` precedent (tasks.md preamble).

/** The `--colony-*` ramp length (`prototype/tokens/colors.css`, group 5): 8 slots,
 * `--colony-0` .. `--colony-7`. Never widen without also widening the modulus here
 * (the `--bee-ext-*` precedent). */
export const COLONY_PALETTE_SIZE = 8;

/** A colony's deterministic colour token: `var(--colony-N)`, `N = colonyId mod
 * COLONY_PALETTE_SIZE` (design D-match-2). Same input -> same output, always —
 * no per-render randomness, no name lookup. */
export function colonyPalette(colonyId: number): string {
  const index = ((colonyId % COLONY_PALETTE_SIZE) + COLONY_PALETTE_SIZE) % COLONY_PALETTE_SIZE;
  return `var(--colony-${index})`;
}

/**
 * A colony's display label (design D-match-1): colony display names are not on the
 * wire (D-074), so every colony reads "Colony {id}" — except the caller's own
 * colony (`ownColonyId`), which reads "You". Deterministic given `(colonyId,
 * ownColonyId)`, so the same colony renders the same label on every surface that
 * shares an `ownColonyId` (the leaderboard's own-row mark).
 */
export function colonyLabel(colonyId: number, ownColonyId?: number | null): string {
  if (ownColonyId != null && colonyId === ownColonyId) {
    return 'You';
  }
  return `Colony ${colonyId}`;
}
